// Pure layout helpers for Quick Capture cards — no React, no DOM mutation.

export const MAX_CAPTURES = 5

// Base anchor for the first card — top-right-ish, matching the original modal.
const baseAnchor = () => ({ x: window.innerWidth - 380, y: 120 })

// Each new card cascades down-and-left from the previous one so none fully hides another.
const OFFSET = { x: -28, y: 28 }

// Position for the Nth open card (0-indexed). Clamped to non-negative coordinates.
export const nextCascadePos = (index) => {
  const base = baseAnchor()
  return {
    x: Math.max(0, base.x + index * OFFSET.x),
    y: Math.max(0, base.y + index * OFFSET.y),
  }
}

// True when no more cards may be opened.
export const atCapacity = (count) => count >= MAX_CAPTURES
